<tt-page *ngIf="!!page">
    <div class="col-xs-12 sp-0 height-full" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
        </tt-card>

        <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="forecastdatagrid_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card>
                        <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #selectionCriterias>
    <ng-container *ngIf="!!page">
        <tt-select ttLabel="forecast" [(ttModel)]="page.forecast_keyno" (ttModelChange)="onChanged($event, 'forecast_keyno')" [ttData]="selectListForecasts" ttDataId="item_id" ttDataName="item_name" ttRequired></tt-select>
        <tt-select ttLabel="seasonality" [(ttModel)]="page.seasonality_keyno" (ttModelChange)="onChanged($event, 'seasonality_keyno')" [ttData]="selectListSeasonalities" ttDataId="item_id" ttDataName="item_name" ttRequired></tt-select>
        <tt-search *ngIf="page.show_supplier_no === '1'" ttLabel="searchtext_supplier" [(ttModel)]="page.searchtext_supplier" [ttSearch]="searchSuppliers" (ttOnSelected)="onSupplierSelected($event)" (ttOnClear)="onSupplierSelected()"></tt-search>
        <label *ngIf="!!page.forecast_history_text" class="checklist-h1 col-xs-12">{{page.forecast_history_text}}</label>

        <div [hidden]="page.forecast_type_id !== 'F'">
            <tt-date ttLabel="history_fom_date" [(ttModel)]="page.history_fom_date" (ttModelChange)="onChanged($event, 'history_fom_date')"></tt-date>
            <tt-date ttLabel="history_tom_date" [(ttModel)]="page.history_tom_date" (ttModelChange)="onChanged($event, 'history_tom_date')"></tt-date>
        </div>

        <div [hidden]="page.forecast_type_id !== 'R'">
            <tt-input-number ttLabel="forecast_history_running_nbr" [(ttModel)]="page.forecast_history_running_nbr" (ttModelChange)="onChanged($event, 'forecast_history_running_nbr')" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
            <tt-date ttLabel="history_fom_date" [ttModel]="page.history_fom_date" (ttModelChange)="onChanged($event, 'history_fom_date')" ttReadonly></tt-date>
            <tt-date ttLabel="history_tom_date" [ttModel]="page.history_tom_date" (ttModelChange)="onChanged($event, 'history_tom_date')" ttReadonly></tt-date>
        </div>

        <tt-input-number ttLabel="history_pst" [ttModel]="page.history_pst" ttTextAlign="right" ttFormatNumber ttDecimals="6" ttReadonly></tt-input-number>
        <label *ngIf="!!page.forecast_forward_text" class="checklist-h1 col-xs-12">{{page.forecast_forward_text}}</label>
        <tt-select ttLabel="forecast_resolution" [(ttModel)]="page.forecast_resolution_id" (ttModelChange)="onChanged($event, 'forecast_resolution_id')" [ttData]="selectListResolutions" ttDataId="forecast_resolution_id" ttDataName="color_name" ttRequired></tt-select>
        <tt-button ttText="gridexportarg_execute" (ttClick)="executeGrid()" [ttSpin]="executing" ttIcon="fas fa-sync"></tt-button>
    </ng-container>
</ng-template>
